import React, { useState, useEffect } from "react";
import ProductDetail0 from "./ProductDetail0";
import ProductDetail1 from "./ProductDetail1";
import ProductDetail2 from "./ProductDetail2";
import ProductDetail3 from "./ProductDetail3";
import ProductDetail4 from "./ProductDetail4";
import { useParams } from "react-router-dom";
import loader from "../../assets/loader.gif";

const productDetails = {
  0: ProductDetail0,
  1: ProductDetail1,
  2: ProductDetail2,
  3: ProductDetail3,
  4: ProductDetail4,
};

// Loader Component
const Loader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <img src={loader} alt="Loading..." className="w-30 h-30" />
  </div>
);

export const ProductDetails = () => {
  const { id } = useParams();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const ADMIN_AUTO_ID = sessionStorage.getItem("admin_auto_id");
  const APP_TYPE_ID = sessionStorage.getItem("app_type_id");

  const [data, setData] = useState(null);
  const [ProductDetailNo, setProductDetailNo] = useState(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    return storedStyle
      ? Number(JSON.parse(storedStyle).product_detail_layout_no) || 0
      : null;
  });

  const getProductData = async () => {
    try {
      setData(null);
      const formData = new FormData();
      formData.append("admin_auto_id", ADMIN_AUTO_ID);
      formData.append("app_type_id", APP_TYPE_ID);
      formData.append("user_auto_id", ADMIN_AUTO_ID);
      formData.append("product_auto_id", id);
      formData.append("customer_auto_id", ADMIN_AUTO_ID);
      formData.append("sub_category_auto_id", ADMIN_AUTO_ID);

      const response = await fetch(`${API_BASE_URL}/get_product_details`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Failed to fetch data");

      const responseData = await response.json();

      if (responseData?.UIStyle) {
        sessionStorage.setItem("UIStyle", JSON.stringify(responseData.UIStyle));
        setProductDetailNo(
          Number(responseData.UIStyle.product_detail_layout_no) || 0
        );
      }

      setData(responseData); // Replace old data
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };

  useEffect(() => {
    getProductData();
  }, [id]);

  const handleDataUpdate = (updatedData) => {
    setData(updatedData);
  };

  if (ProductDetailNo === null || data === null) {
    return <Loader />;
  }


  // const SelectedProductDetailPage = ProductDetail1;

  const SelectedProductDetailPage =
    productDetails[4] || ProductDetail0;
  // productDetails[1] || ProductDetail0;

  return (
    <div>
      <SelectedProductDetailPage data={data} onDataUpdate={handleDataUpdate} />
    </div>
  );
};

export default ProductDetails;